module.exports = __webpack_public_path__ + "static/media/checkbox_checked1.bb6cb0d6.svg";